(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["emo-hair-ritual"] && !Shopify.designMode) return;
  try {
    
function initHairFormCopy(){const root=document.querySelector('.ehr-order-card');if(!root)return;const update=()=>{const city=root.querySelector('#_rsi-field-city');if(!city)return false;city.setAttribute('placeholder','اكتب مدينتك بالعربية أو بالحروف اللاتينية');return true;};if(update())return;const observer=new MutationObserver(()=>{if(update())observer.disconnect();});observer.observe(root,{childList:true,subtree:true});}
if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initHairFormCopy,{once:true});}else{initHairFormCopy();}

function initHairExtras(){document.querySelectorAll('[data-ehr-extras]').forEach(root=>{if(root.dataset.ready||root.dataset.preview!=='true')return;root.dataset.ready='true';const selected=new Map();const buttons=[...root.querySelectorAll('[data-addon-sku]')];const update=()=>{const rows=[...selected.values()],total=Number(root.dataset.base)+rows.reduce((a,b)=>a+b.price,0);root.querySelector('[data-extra-total]').textContent=String(total);root.querySelector('[data-extra-list]').textContent=rows.length?rows.map(x=>x.title).join(' + '):'الباك بدون إضافات';const page=root.closest('.ehr'),orderTotal=page.querySelector('[data-ehr-order-total]'),note=page.querySelector('[data-ehr-order-extras]');if(orderTotal)orderTotal.textContent=String(total);if(note){note.hidden=!rows.length;note.textContent=rows.length?'الإضافات: '+rows.map(x=>x.title).join(' + '):'';}buttons.forEach(button=>{const on=selected.has(button.dataset.addonSku);button.setAttribute('aria-pressed',String(on));button.textContent=on?'تمت الإضافة ✓ · إزالة':'أضف إلى الباك · +'+button.dataset.addonPrice+' د.ل';});};buttons.forEach(button=>button.addEventListener('click',()=>{const key=button.dataset.addonSku;if(selected.has(key))selected.delete(key);else selected.set(key,{sku:key,variant:button.dataset.addonVariant,title:button.dataset.addonTitle,price:Number(button.dataset.addonPrice)});update();}));update();});}
initHairExtras();document.addEventListener('shopify:section:load',initHairExtras);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["emo-home-catalog"] && !Shopify.designMode) return;
  try {
    
(() => {
  function init(root) {
    if (root.dataset.emoHomeReady) return;
    root.dataset.emoHomeReady = 'true';
    const cards = Array.from(root.querySelectorAll('[data-emo-home-card]'));
    const buttons = Array.from(root.querySelectorAll('[data-emo-category]'));
    const count = root.querySelector('[data-emo-home-count]');
    buttons.forEach(button => {
      const category = button.dataset.emoCategory;
      if (category !== 'all' && !cards.some(card => card.dataset.category === category)) button.hidden = true;
      button.addEventListener('click', () => {
        let shown = 0;
        cards.forEach(card => { card.hidden = category !== 'all' && card.dataset.category !== category; if (!card.hidden) shown++; });
        buttons.forEach(other => other.setAttribute('aria-pressed', String(other === button)));
        count.textContent = root.dataset.countFormat.replace('__COUNT__', String(shown));
      });
    });
    root.addEventListener('click', event => {
      const link = event.target.closest('a[href="#emo-kitchen-city"]');
      if (link && root.contains(link)) {
        const panel = root.querySelector('#emo-kitchen-city');
        if (panel) panel.open = true;
      }
    }, true);
  }
  function initialize() { document.querySelectorAll('[data-emo-home-catalog]').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initialize, {once:true}); else initialize();
  document.addEventListener('shopify:section:load', initialize);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
